import React, { useEffect } from "react";
import environment from "constants/apiConst";
import { useQuery } from "@tanstack/react-query";
import { ModalGeneric } from "./ModalGeneric";
import { Box, Text } from "@chakra-ui/react";
import { ButtonStyled } from "styled/Buttons.styled";
import { useGlobalContext } from "context/GlobalContext";
import ReturnHistoryTable from "components/Tables/ReturnHistoryTable";

const ModalReturnHistory = ({
  isOpen,
  onOpen,
  onClose,
  title = "Historial de Devoluciones",
  size = "3xl",
  entryFormId,
  isOutputForm = false,
  isIntegrationCertificate = false,
  isEntryFormCorrected = false,
  isOutputFormCorrected = false,
  isIntegrationCertificateCorrected = false,
  isCustomsClearance = false,
}) => {
  const { requestData } = useGlobalContext();

  const endpoint = isCustomsClearance
    ? `${environment.GET_RETURN_HISTORY_CUSTOMS_CLEARANCE}/${entryFormId}`
    : isIntegrationCertificateCorrected
    ? `${environment.GET_RETURN_HISTORY_INTEGRATION_CORRECTED}/${entryFormId}`
    : isOutputFormCorrected
    ? `${environment.GET_RETURN_HISTORY_OUTPUT_CORRECTED}/${entryFormId}`
    : isEntryFormCorrected
    ? `${environment.GET_RETURN_HISTORY_ENTRY_CORRECTED}/${entryFormId}`
    : isIntegrationCertificate
    ? `${environment.GET_RETURN_HISTORY_INTEGRATION}/${entryFormId}`
    : isOutputForm 
    ? `${environment.GET_RETURN_HISTORY_OUTPUT}/${entryFormId}`
    : `${environment.GET_RETURN_HISTORY_ENTRY}/${entryFormId}`;
  
  const queryKey = isCustomsClearance
    ? ['RETURN_HISTORY_CUSTOMS_CLEARANCE', entryFormId]
    : isIntegrationCertificateCorrected
    ? ['RETURN_HISTORY_INTEGRATION_CERTIFICATE_CORRECTED', entryFormId]
    : isOutputFormCorrected
    ? ['RETURN_HISTORY_OUTPUT_FORM_CORRECTED', entryFormId]
    : isEntryFormCorrected
    ? ['RETURN_HISTORY_ENTRY_FORM_CORRECTED', entryFormId]
    : isIntegrationCertificate
    ? ['RETURN_HISTORY_INTEGRATION_CERTIFICATE', entryFormId]
    : isOutputForm 
    ? ['RETURN_HISTORY_OUTPUT_FORM', entryFormId]
    : ['RETURN_HISTORY_ENTRY_FORM', entryFormId];

  const { data: returnHistoryData, isLoading: isLoadingReturnHistory, error: errorReturnHistory, refetch: refetchReturnHistory } = useQuery({
    queryKey: queryKey,
    queryFn: () => requestData({ Endpoint: endpoint }),
    enabled: false, // Deshabilita la ejecución automática
  });

  // Ejecuta la petición cuando se abre el modal
  useEffect(() => {
    if (isOpen && entryFormId) {
      refetchReturnHistory();
    }
  }, [isOpen, entryFormId, refetchReturnHistory]);

  const returnHistory = returnHistoryData?.data?.status?.data || [];

  return (
    <ModalGeneric
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      title={title}
      size={size}
    >
      <Box>
        {isLoadingReturnHistory ? (
          <Box p={4} textAlign="center">
            <Text>Cargando historial de devoluciones...</Text>
          </Box>
        ) : errorReturnHistory ? (
          <Box p={4} textAlign="center">
            <Text color="red.500">Error al cargar el historial de devoluciones</Text>
          </Box>
        ) : (
          <ReturnHistoryTable returnHistory={returnHistory} />
        )}

        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          flexWrap={"wrap"}
          mt={4}
        >
          <ButtonStyled onClick={() => onClose(false)} variant="outline" color="black" bgColor="gray.200">
            Cerrar
          </ButtonStyled>
        </Box>
      </Box>
    </ModalGeneric>
  );
};

export default ModalReturnHistory;
